import axios from "axios";
import api from '../api/'
module.exports = {
    login: function (username, password, callback) {
        this.getToken(username, password, (response) => {
            if (response.success) {
                localStorage.token = response.token;
                localStorage.permisos = JSON.stringify(response.permisos);
                if (callback) callback({
                    "success": true
                });
            } else {
                if (callback) callback({
                    "success": false,
                    "errors": response.errors
                });
            }
        })
    },

    logout: function () {
        axios.post(api.authLogout, {
                Token: localStorage.token
            })
            .then(function (response) {
                delete localStorage.token;
                delete localStorage.permisos;
                window.location.reload();
            })
            .catch(function (e) {
            })
    },

    isLoggedIn: async function () {
        if (typeof (localStorage.token) != "undefined") {
            var response = await this.checkToken(localStorage.token);
            if (response.success) {
                this.updatePermission(localStorage.token);
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    },

    checkToken: async function (token) {
        return (await axios.post(api.authCheck, {
            Token: token
        })).data;
    },

    hasPermission: function (permission) {
        if (localStorage.permisos != "" && localStorage.permisos != undefined) {
            var permisos = JSON.parse(localStorage.permisos);
            if (permisos.filter(x => x == permission).length > 0) {
                return true;
            } else {
                return false;
            }
        }
    },

    updatePermission: function (token) {
        var self = this;
        axios.get(api.authGetPermissions, {
                headers: {
                    "Authorization": "Token " + token
                }
            })
            .then(function (response) {
                if (response.data.success) {
                    localStorage.permisos = JSON.stringify(response.data.permisos);
                } else {
                    self.logout();
                }
            })
    },

    token: function () {
        return localStorage.token;
    },

    header: function () {
        return {
            headers: {
                "Authorization": "Token " + localStorage.token,
            },
        };
    },

    fileFormHeader: function () {
        return {
            headers: {
                "Authorization": "Token " + localStorage.token,
                "Content-Type": "multipart/form-data"
            },
            async: false,
            cache: false,
            contentType: false,
            processData: false,
        };
    },


    getToken: function (username, password, callback) {
        axios.post(api.auth, {
                username: username,
                password: password
            })
            .then(function (response) {
                if (response.status == 200) {
                    if (response.data.iduser) localStorage.iduser = response.data.iduser
                    localStorage.display = response.data.display;
                    if (callback) callback(response.data);
                } else
                if (callback) callback({
                    "success": false
                })
            })
            .catch(function (e) {
                if (callback) callback({
                    "success": false
                })
            })
    },
}


// WEBPACK FOOTER //
// ./src/auth/auth.js